module.exports = "span {\n  float: right;\n  bottom: -20px;\n  position: relative;\n  right: 10px;\n  font-size: 12px;\n  color: whitesmoke;\n}\n\nmd-slider {\n  width: 100%;\n}\n\nplayer .md-slider-track {\n  height: 5px !important;\n  background: #fff;\n}\n\n.md-slider-track {\n  background-color: whitesmoke;\n}\n\n.md-slider-horizontal .md-slider-track-fill {\n  height: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/seek-track/seek-track.component.css
// module id = ./src/app/player/seek-track/seek-track.component.css
// module chunks = main